/** Must match backend `approval-entity-types.ts` / workflow `entity_type` in DB. */
export const ENTITY_TYPE_PURCHASE_ORDER = 'purchase_order';
export const ENTITY_TYPE_SUPPLIER_ADVANCE_REQUEST = 'supplier_advance_request';
export const ENTITY_TYPE_INLAND_PROCESS_DEVIATION = 'inland_process_deviation';
export const ENTITY_TYPE_PURCHASE_REQUISITION = 'purchase_requisition';
export const ENTITY_TYPE_GOODS_RECEIPT_NOTE = 'goods_receipt_note';
export const ENTITY_TYPE_SERVICE_RECEIPT = 'service_receipt';
export const ENTITY_TYPE_PO_MILESTONE = 'po_milestone';
export const ENTITY_TYPE_PURCHASE_RETURN = 'purchase_return';
export const ENTITY_TYPE_SUPPLIER_INVOICE = 'supplier_invoice';
export const ENTITY_TYPE_PAYMENT_VOUCHER = 'payment_voucher';
export const ENTITY_TYPE_RECEIPT_VOUCHER = 'receipt_voucher';
export const ENTITY_TYPE_JOURNAL_VOUCHER = 'journal_voucher';
export const ENTITY_TYPE_SALES_ORDER = 'sales_order';
export const ENTITY_TYPE_SALES_INVOICE = 'sales_invoice';
export const ENTITY_TYPE_SALES_ORDER_TIMESHEET = 'sales_order_timesheet';
export const ENTITY_TYPE_MATERIAL_REQUEST = 'material_request';
export const ENTITY_TYPE_STOCK_ADJUSTMENT = 'stock_adjustment';
export const ENTITY_TYPE_STOCK_TRANSFER = 'stock_transfer';
export const ENTITY_TYPE_MATERIAL_ISSUANCE = 'material_issuance';
export const ENTITY_TYPE_QUOTATION = 'quotation';
export const ENTITY_TYPE_ESTIMATION = 'estimation';
export const ENTITY_TYPE_ASSEMBLY_ESTIMATE = 'assembly_estimate';
export const ENTITY_TYPE_PRODUCTION_REQUEST = 'production_request';
export const ENTITY_TYPE_PROJECT_TIMESHEET = 'project_timesheet';
export const ENTITY_TYPE_ASSET_CAPITALIZATION = 'asset_capitalization';
export const ENTITY_TYPE_ASSET_DISPOSAL = 'asset_disposal';
export const ENTITY_TYPE_ASSET_TRANSFER = 'asset_transfer';
/** Management of Change — universal approval (`approval_instances.entity_type`). */
export const ENTITY_TYPE_MOC = 'management_of_change';
export const ENTITY_TYPE_EPC_PERMIT = 'epc_permit';
export const ENTITY_TYPE_EPC_BID_DECISION = 'epc_bid_decision';
export const ENTITY_TYPE_EPC_TENDER_SUBMISSION = 'epc_tender_submission';
export const ENTITY_TYPE_EPC_AWARD_ACCEPTANCE = 'epc_award_acceptance';
export const ENTITY_TYPE_EPC_ESTIMATE = 'epc_estimate';
export const ENTITY_TYPE_EPC_PROJECT_MOBILIZATION = 'epc_project_mobilization';
export const ENTITY_TYPE_EPC_CONTRACT = 'epc_contract';
export const ENTITY_TYPE_EPC_PAYMENT_APPLICATION = 'epc_payment_application';
export const ENTITY_TYPE_EPC_VARIATION = 'epc_variation';
export const ENTITY_TYPE_EPC_CLAIM = 'epc_claim';
export const ENTITY_TYPE_EPC_EOT = 'epc_eot';
export const ENTITY_TYPE_EPC_FINAL_ACCOUNT = 'epc_final_account';
export const ENTITY_TYPE_EPC_CONTRACT_CLOSEOUT = 'epc_contract_closeout';

export const ENTITY_TYPE_SUBCONTRACTOR_AGREEMENT = 'subcontractor_agreement';
export const ENTITY_TYPE_SUBCONTRACT_PAYMENT_CERTIFICATE = 'subcontract_payment_certificate';
export const ENTITY_TYPE_SUBCONTRACT_VARIATION = 'subcontract_variation';
export const ENTITY_TYPE_SUBCONTRACT_CLAIM = 'subcontract_claim';
export const ENTITY_TYPE_SUBCONTRACT_EOT = 'subcontract_eot';
export const ENTITY_TYPE_SUBCONTRACT_FINAL_ACCOUNT = 'subcontract_final_account';
export const ENTITY_TYPE_SUBCONTRACT_CLOSEOUT = 'subcontract_closeout';

export const ENTITY_TYPE_CONTRACT_REVIEW = 'contract_review';
export const ENTITY_TYPE_ORDER_REVIEW_CHECKLIST = 'order_review_checklist';
export const ENTITY_TYPE_DOCUMENT_COLLECTION = 'document_collection_request';

/** Project Cost Budget revision — Current Budget promotion via Approval Runtime. */
export const ENTITY_TYPE_PROJECT_BUDGET_REVISION = 'project_budget_revision';

/** Authorize overspend against Current Budget (does not rewrite budget). */
export const ENTITY_TYPE_PROJECT_BUDGET_EXCEEDANCE = 'project_budget_exceedance';

/** Intercompany transaction (goods transfer / service recharge). */
export const ENTITY_TYPE_INTERCOMPANY_TRANSACTION = 'intercompany_transaction';

/** HRMS — Approval Runtime entity types. */
export const ENTITY_TYPE_HR_LEAVE_APPLICATION = 'hr_leave_application';
export const ENTITY_TYPE_HR_OT_REQUEST = 'hr_ot_request';
export const ENTITY_TYPE_HR_SALARY_REVISION = 'hr_salary_revision';
export const ENTITY_TYPE_HR_EMPLOYMENT_CONTRACT = 'hr_employment_contract';
export const ENTITY_TYPE_HR_PAYROLL_PERIOD = 'hr_payroll_period';
export const ENTITY_TYPE_HR_EOSB_SETTLEMENT = 'hr_eosb_settlement';
export const ENTITY_TYPE_HR_LEAVE_SETTLEMENT = 'hr_leave_settlement';
export const ENTITY_TYPE_HR_LOAN = 'hr_loan';
export const ENTITY_TYPE_HR_TIMESHEET_MONTH = 'hr_timesheet_month';
export const ENTITY_TYPE_HR_PROFILE_CHANGE = 'hr_profile_change_request';
export const ENTITY_TYPE_HR_MANPOWER_REQUISITION = 'hr_manpower_requisition';
export const ENTITY_TYPE_HR_OFFER = 'hr_offer';
export const ENTITY_TYPE_HR_LETTER_REQUEST = 'hr_letter_request';
/** HRMS accrual accounting valuation batch (leave/EOSB → Finance JV). */
export const ENTITY_TYPE_HR_ACCRUAL_BATCH = 'hr_accrual_batch';
/** EOSB statutory rule-pack activation. */
export const ENTITY_TYPE_HR_EOSB_STATUTORY_PACK = 'hr_eosb_statutory_pack';

/** Quality — NCR / CAPA via Universal Approval Runtime. */
export const ENTITY_TYPE_NCR_RECORD = 'ncr_record';
export const ENTITY_TYPE_CAPA_RECORD = 'capa_record';
/** Receiving Inspection (GRN QC) via Universal Approval Runtime. */
export const ENTITY_TYPE_RECEIVING_INSPECTION = 'receiving_inspection';
/** Receiving Dimension Inspection via Universal Approval Runtime. */
export const ENTITY_TYPE_RECEIVING_DIMENSIONAL_INSPECTION = 'receiving_dimensional_inspection';
/** Stage Completion Inspection (production stage QC) via Universal Approval Runtime. */
export const ENTITY_TYPE_STAGE_INSPECTION = 'stage_inspection';
/** Finance Recognition Engine (prepaid expense) — contract approval and adjustment approval. */
export const ENTITY_TYPE_RECOGNITION_CONTRACT = 'recognition_contract';
export const ENTITY_TYPE_RECOGNITION_REVISION = 'recognition_revision';
export const ENTITY_TYPE_EDUCATION_ADMISSION = 'education_admission';
export const ENTITY_TYPE_EDUCATION_ENROLLMENT = 'education_enrollment';
export const ENTITY_TYPE_EDUCATION_WITHDRAWAL = 'education_withdrawal';
export const ENTITY_TYPE_EDUCATION_PROGRESSION = 'education_progression_batch';
export const ENTITY_TYPE_EDUCATION_LEAVE = 'education_student_leave';
export const ENTITY_TYPE_EDUCATION_ATTENDANCE_AMENDMENT = 'education_attendance_amendment';
export const ENTITY_TYPE_EDUCATION_FEE_CONCESSION = 'education_fee_concession';
export const ENTITY_TYPE_EDUCATION_FEE_DISPUTE = 'education_fee_dispute';
export const ENTITY_TYPE_EDUCATION_INTERVENTION_OUTCOME = 'education_intervention_outcome';
export const ENTITY_TYPE_EDUCATION_APP_PLAN = 'education_app_plan';

/** Display labels for Platform → Approval Workflows (fallback: raw code). */
export const APPROVAL_WORKFLOW_ENTITY_TYPE_LABELS: Partial<Record<string, string>> = {
  [ENTITY_TYPE_MOC]: 'Management of Change (MOC)',
  [ENTITY_TYPE_NCR_RECORD]: 'NCR (Non-Conformance Report)',
  [ENTITY_TYPE_CAPA_RECORD]: 'CAPA (Corrective / Preventive Action)',
  [ENTITY_TYPE_RECEIVING_INSPECTION]: 'Receiving Inspection (GRN QC)',
  [ENTITY_TYPE_RECEIVING_DIMENSIONAL_INSPECTION]: 'Receiving Dimension Inspection',
  [ENTITY_TYPE_STAGE_INSPECTION]: 'Stage Inspection',
  [ENTITY_TYPE_EPC_PERMIT]: 'CEP Permit-to-Work (PTW)',
  [ENTITY_TYPE_EPC_BID_DECISION]: 'EPC Bid Decision',
  [ENTITY_TYPE_EPC_TENDER_SUBMISSION]: 'EPC Tender Submission',
  [ENTITY_TYPE_EPC_AWARD_ACCEPTANCE]: 'EPC Award Acceptance',
  [ENTITY_TYPE_EPC_ESTIMATE]: 'EPC Estimate Revision',
  [ENTITY_TYPE_ASSEMBLY_ESTIMATE]: 'Assembly-Based Estimation',
  [ENTITY_TYPE_EPC_PROJECT_MOBILIZATION]: 'EPC Project Mobilization',
  [ENTITY_TYPE_EPC_CONTRACT]: 'EPC Contract',
  [ENTITY_TYPE_EPC_PAYMENT_APPLICATION]: 'EPC Payment Application (IPC)',
  [ENTITY_TYPE_EPC_VARIATION]: 'EPC Variation',
  [ENTITY_TYPE_EPC_CLAIM]: 'EPC Claim',
  [ENTITY_TYPE_EPC_EOT]: 'EPC Extension of Time',
  [ENTITY_TYPE_EPC_FINAL_ACCOUNT]: 'EPC Final Account',
  [ENTITY_TYPE_EPC_CONTRACT_CLOSEOUT]: 'EPC Contract Closeout',
  [ENTITY_TYPE_SUBCONTRACTOR_AGREEMENT]: 'Subcontractor Agreement',
  [ENTITY_TYPE_SUBCONTRACT_PAYMENT_CERTIFICATE]: 'Subcontract Payment Certificate (SPC)',
  [ENTITY_TYPE_SUBCONTRACT_VARIATION]: 'Subcontract Variation',
  [ENTITY_TYPE_SUBCONTRACT_CLAIM]: 'Subcontract Claim',
  [ENTITY_TYPE_SUBCONTRACT_EOT]: 'Subcontract Extension of Time',
  [ENTITY_TYPE_SUBCONTRACT_FINAL_ACCOUNT]: 'Subcontract Final Account',
  [ENTITY_TYPE_SUBCONTRACT_CLOSEOUT]: 'Subcontract Closeout',
  [ENTITY_TYPE_CONTRACT_REVIEW]: 'Contract Review',
  [ENTITY_TYPE_ORDER_REVIEW_CHECKLIST]: 'Order Review Checklist',
  [ENTITY_TYPE_DOCUMENT_COLLECTION]: 'Document Collection',
  [ENTITY_TYPE_PRODUCTION_REQUEST]: 'Production Request',
  [ENTITY_TYPE_MATERIAL_ISSUANCE]: 'Material Issuance',
  [ENTITY_TYPE_SERVICE_RECEIPT]: 'Service Receipt',
  [ENTITY_TYPE_PAYMENT_VOUCHER]: 'Payment Voucher',
  [ENTITY_TYPE_RECEIPT_VOUCHER]: 'Receipt Voucher',
  [ENTITY_TYPE_SUPPLIER_ADVANCE_REQUEST]: 'Supplier Advance Request',
  [ENTITY_TYPE_PROJECT_BUDGET_REVISION]: 'Project Budget Revision',
  [ENTITY_TYPE_PROJECT_BUDGET_EXCEEDANCE]: 'Project Budget Exceedance',
  [ENTITY_TYPE_INTERCOMPANY_TRANSACTION]: 'Intercompany Transaction',
  [ENTITY_TYPE_HR_LEAVE_APPLICATION]: 'HR Leave Application',
  [ENTITY_TYPE_HR_OT_REQUEST]: 'HR Overtime Request',
  [ENTITY_TYPE_HR_SALARY_REVISION]: 'HR Salary Revision',
  [ENTITY_TYPE_HR_EMPLOYMENT_CONTRACT]: 'HR Employment Contract',
  [ENTITY_TYPE_HR_PAYROLL_PERIOD]: 'HR Payroll Period',
  [ENTITY_TYPE_HR_EOSB_SETTLEMENT]: 'HR EOSB Settlement',
  [ENTITY_TYPE_HR_LEAVE_SETTLEMENT]: 'HR Leave Settlement',
  [ENTITY_TYPE_HR_LOAN]: 'HR Loan',
  [ENTITY_TYPE_HR_TIMESHEET_MONTH]: 'HR Timesheet Month',
  [ENTITY_TYPE_HR_PROFILE_CHANGE]: 'HR Profile Change Request',
  [ENTITY_TYPE_HR_MANPOWER_REQUISITION]: 'HR Manpower Requisition',
  [ENTITY_TYPE_HR_OFFER]: 'HR Job Offer',
  [ENTITY_TYPE_HR_LETTER_REQUEST]: 'HR Employee Letter Request',
  [ENTITY_TYPE_HR_ACCRUAL_BATCH]: 'HR Accrual Accounting Batch',
  [ENTITY_TYPE_HR_EOSB_STATUTORY_PACK]: 'HR EOSB Statutory Rule Pack',
  [ENTITY_TYPE_SALES_ORDER_TIMESHEET]: 'Customer Order Timesheet',
  [ENTITY_TYPE_RECOGNITION_CONTRACT]: 'Prepaid / Recognition Contract',
  [ENTITY_TYPE_RECOGNITION_REVISION]: 'Prepaid / Recognition Adjustment',
  [ENTITY_TYPE_EDUCATION_ADMISSION]: 'Education admission',
  [ENTITY_TYPE_EDUCATION_ENROLLMENT]: 'Education enrollment',
  [ENTITY_TYPE_EDUCATION_WITHDRAWAL]: 'Education withdrawal',
  [ENTITY_TYPE_EDUCATION_PROGRESSION]: 'Education progression batch',
  [ENTITY_TYPE_EDUCATION_LEAVE]: 'Education student leave',
  [ENTITY_TYPE_EDUCATION_ATTENDANCE_AMENDMENT]: 'Education attendance correction',
  [ENTITY_TYPE_EDUCATION_FEE_CONCESSION]: 'Education fee concession',
  [ENTITY_TYPE_EDUCATION_FEE_DISPUTE]: 'Education fee dispute',
  [ENTITY_TYPE_EDUCATION_INTERVENTION_OUTCOME]: 'Education intervention outcome',
  [ENTITY_TYPE_EDUCATION_APP_PLAN]: 'Education Annual Pedagogical Plan',
};

export function approvalWorkflowEntityTypeLabel(code: string): string {
  return APPROVAL_WORKFLOW_ENTITY_TYPE_LABELS[code] ?? code;
}

/** List/table: show friendly name and technical code when a label exists. */
export function approvalWorkflowEntityTypeDisplay(code: string): string {
  const label = approvalWorkflowEntityTypeLabel(code);
  return label === code ? code : `${label} (${code})`;
}

/** Ordered list for Platform → Approval workflows entity type dropdown (must match backend). */
export const APPROVAL_WORKFLOW_ENTITY_TYPE_VALUES: readonly string[] = [
  ENTITY_TYPE_PURCHASE_ORDER,
  ENTITY_TYPE_SUPPLIER_ADVANCE_REQUEST,
  ENTITY_TYPE_INLAND_PROCESS_DEVIATION,
  ENTITY_TYPE_PURCHASE_REQUISITION,
  ENTITY_TYPE_GOODS_RECEIPT_NOTE,
  ENTITY_TYPE_SERVICE_RECEIPT,
  ENTITY_TYPE_PO_MILESTONE,
  ENTITY_TYPE_PURCHASE_RETURN,
  ENTITY_TYPE_SUPPLIER_INVOICE,
  ENTITY_TYPE_PAYMENT_VOUCHER,
  ENTITY_TYPE_RECEIPT_VOUCHER,
  ENTITY_TYPE_JOURNAL_VOUCHER,
  ENTITY_TYPE_SALES_ORDER,
  ENTITY_TYPE_SALES_INVOICE,
  ENTITY_TYPE_SALES_ORDER_TIMESHEET,
  ENTITY_TYPE_MATERIAL_REQUEST,
  ENTITY_TYPE_STOCK_ADJUSTMENT,
  ENTITY_TYPE_STOCK_TRANSFER,
  ENTITY_TYPE_MATERIAL_ISSUANCE,
  ENTITY_TYPE_QUOTATION,
  ENTITY_TYPE_ESTIMATION,
  ENTITY_TYPE_ASSEMBLY_ESTIMATE,
  ENTITY_TYPE_PRODUCTION_REQUEST,
  ENTITY_TYPE_PROJECT_TIMESHEET,
  ENTITY_TYPE_ASSET_CAPITALIZATION,
  ENTITY_TYPE_ASSET_DISPOSAL,
  ENTITY_TYPE_ASSET_TRANSFER,
  ENTITY_TYPE_MOC,
  ENTITY_TYPE_EPC_PERMIT,
  ENTITY_TYPE_EPC_BID_DECISION,
  ENTITY_TYPE_EPC_TENDER_SUBMISSION,
  ENTITY_TYPE_EPC_AWARD_ACCEPTANCE,
  ENTITY_TYPE_EPC_ESTIMATE,
  ENTITY_TYPE_EPC_PROJECT_MOBILIZATION,
  ENTITY_TYPE_EPC_CONTRACT,
  ENTITY_TYPE_EPC_PAYMENT_APPLICATION,
  ENTITY_TYPE_EPC_VARIATION,
  ENTITY_TYPE_EPC_CLAIM,
  ENTITY_TYPE_EPC_EOT,
  ENTITY_TYPE_EPC_FINAL_ACCOUNT,
  ENTITY_TYPE_EPC_CONTRACT_CLOSEOUT,
  ENTITY_TYPE_SUBCONTRACTOR_AGREEMENT,
  ENTITY_TYPE_SUBCONTRACT_PAYMENT_CERTIFICATE,
  ENTITY_TYPE_SUBCONTRACT_VARIATION,
  ENTITY_TYPE_SUBCONTRACT_CLAIM,
  ENTITY_TYPE_SUBCONTRACT_EOT,
  ENTITY_TYPE_SUBCONTRACT_FINAL_ACCOUNT,
  ENTITY_TYPE_SUBCONTRACT_CLOSEOUT,
  ENTITY_TYPE_CONTRACT_REVIEW,
  ENTITY_TYPE_ORDER_REVIEW_CHECKLIST,
  ENTITY_TYPE_DOCUMENT_COLLECTION,
  ENTITY_TYPE_PROJECT_BUDGET_REVISION,
  ENTITY_TYPE_PROJECT_BUDGET_EXCEEDANCE,
  ENTITY_TYPE_INTERCOMPANY_TRANSACTION,
  ENTITY_TYPE_HR_LEAVE_APPLICATION,
  ENTITY_TYPE_HR_OT_REQUEST,
  ENTITY_TYPE_HR_SALARY_REVISION,
  ENTITY_TYPE_HR_EMPLOYMENT_CONTRACT,
  ENTITY_TYPE_HR_PAYROLL_PERIOD,
  ENTITY_TYPE_HR_EOSB_SETTLEMENT,
  ENTITY_TYPE_HR_LEAVE_SETTLEMENT,
  ENTITY_TYPE_HR_LOAN,
  ENTITY_TYPE_HR_TIMESHEET_MONTH,
  ENTITY_TYPE_HR_PROFILE_CHANGE,
  ENTITY_TYPE_HR_MANPOWER_REQUISITION,
  ENTITY_TYPE_HR_OFFER,
  ENTITY_TYPE_HR_LETTER_REQUEST,
  ENTITY_TYPE_HR_ACCRUAL_BATCH,
  ENTITY_TYPE_HR_EOSB_STATUTORY_PACK,
  ENTITY_TYPE_NCR_RECORD,
  ENTITY_TYPE_CAPA_RECORD,
  ENTITY_TYPE_RECEIVING_INSPECTION,
  ENTITY_TYPE_RECEIVING_DIMENSIONAL_INSPECTION,
  ENTITY_TYPE_STAGE_INSPECTION,
  ENTITY_TYPE_RECOGNITION_CONTRACT,
  ENTITY_TYPE_RECOGNITION_REVISION,
  ENTITY_TYPE_EDUCATION_ADMISSION,
  ENTITY_TYPE_EDUCATION_ENROLLMENT,
  ENTITY_TYPE_EDUCATION_WITHDRAWAL,
  ENTITY_TYPE_EDUCATION_PROGRESSION,
  ENTITY_TYPE_EDUCATION_LEAVE,
  ENTITY_TYPE_EDUCATION_ATTENDANCE_AMENDMENT,
  ENTITY_TYPE_EDUCATION_FEE_CONCESSION,
  ENTITY_TYPE_EDUCATION_FEE_DISPUTE,
  ENTITY_TYPE_EDUCATION_INTERVENTION_OUTCOME,
  ENTITY_TYPE_EDUCATION_APP_PLAN,
];
